/* **************************
   WICHTIG!
   **************************
   in der Klasse wurden static Attribute verwendet, 
   um eine Endlosschleife im hook zu verhindern.
*/

export default class FormValidatorCtxBo {

    // Sobald sich der Wert verändert, wird die Routine für die Validierung ausgefuehrt
    // siehe useInputValidator
    static runFormValidationTrigger = 0;

    static runFormValidation = false;

    static error = false;

    static errorKeyList: string[] = [];

    static doOnSubmitButton?: (error: boolean) => void;

    static prepareFormValidationStart() {
        FormValidatorCtxBo.runFormValidation = true;
        FormValidatorCtxBo.errorKeyList = [];
        FormValidatorCtxBo.error = false;
        FormValidatorCtxBo.runFormValidationTrigger = ++FormValidatorCtxBo.runFormValidationTrigger;
    }

    static prepareFormValidationEnd() {
        FormValidatorCtxBo.runFormValidation = false;
    }

    static addError(key: string) {
        const index = FormValidatorCtxBo.errorKeyList.indexOf(key);
        if (index === -1) {
            FormValidatorCtxBo.errorKeyList.push(key);
        }

        FormValidatorCtxBo.error = FormValidatorCtxBo.errorKeyList.length > 0;
    }

    static removeError(key: string) {

        const index = FormValidatorCtxBo.errorKeyList.indexOf(key);
        if (index > -1) {
            FormValidatorCtxBo.errorKeyList.splice(index, 1);
        }

        FormValidatorCtxBo.error = FormValidatorCtxBo.errorKeyList.length > 0;
    }

}